export default __webpack_public_path__ + "static/media/active.25079cbb.png";